module.exports = __webpack_public_path__ + "assets/img/Aussie-Broadband-eBook-w540.86e2421b.webp";